exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Header-cbf6886b{position:fixed;background:#FFF;top:0;left:0;right:0;z-index:999}li.lessMargin-d0c3d539{margin:0 5px !important}.saveStatus-ebdbd48c{color:#999}.moreList-7728d3da{list-style-type:none;margin:0 0;padding:0 0;width:100px}.moreList-7728d3da>li{margin:0 0;padding:10px 10px;color:#666;background:white;cursor:pointer;border-bottom:1px solid #bbb}.moreList-7728d3da>li:hover{color:#333}.moreList-7728d3da>li a,.moreList-7728d3da>li a:visited,.moreList-7728d3da>li a:hover{color:inherit;text-decoration:none}.moreList-7728d3da>li a.delete-c9c3b74f{color:#b71c1c}.moreList-7728d3da>li a.delete-c9c3b74f:hover{color:#751212}.moreList-7728d3da>li:last-child{border-bottom:none}.errorMessage-14550540{color:#b71c1c}\n", ""]);

// Exports
exports.locals = {
	"Header": "Header-cbf6886b",
	"lessMargin": "lessMargin-d0c3d539",
	"saveStatus": "saveStatus-ebdbd48c",
	"moreList": "moreList-7728d3da",
	"delete": "delete-c9c3b74f",
	"errorMessage": "errorMessage-14550540"
};